<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="componentBindings"
        :table-action="true"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn"/>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="主条码" prop="productionNo">
            <el-input v-model="filter.barcode" clearable/>
          </el-form-item>
          <el-form-item label="工单号" prop="station">
            <el-input v-model="filter.productionOrderNo" clearable/>
          </el-form-item>
          <el-form-item label="物料号" prop="station">
            <el-input v-model="filter.materialNo" clearable/>
          </el-form-item>
          <el-form-item label="部件物料号" prop="station">
            <el-input v-model="filter.componentMaterialNo" clearable/>
          </el-form-item>
          <el-form-item label="部件条码" prop="station">
            <el-input v-model="filter.componentBarcode" placeholder="单个模糊搜索" clearable/>
          </el-form-item>
          <el-form-item label="部件条码" prop="station">
            <el-input v-model="filter.componentBarcodeBatch" placeholder="多个精准搜索" type="textarea"/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <component-binding-edit
        :visible.sync="editVisible"
        :data="editData"
        @submit="submitHandle"
    />
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ComponentBindingEdit from "./ComponentBindingEdit.vue";

  export default {
    name: "ComponentBindingList",
    components: { viewTable, ComponentBindingEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(56),
          editAuth: this.$auth(56),
          delAuth: this.$auth(57),
        },
        filter: {
          isEnd: "",
          productionNo: "",
          station: "",
          componentMaterialNo: "",
          componentBarcode: "",
          componentBarcodeBatch:"",
        },
        selection: [],
        editVisible: false,
        editData: {},
        columnsProperty: [
          {
            tooltip: true, key: "barcode", width: 160, align: "center" },
          {
            tooltip: true, key: "productionOrderNo", width: 160, align: "center" },
          {
            tooltip: true, key: "materialNo", width: 160, align: "center" },
          {
            tooltip: true, key: "componentMaterialNo", width: 160, align: "center" },
          {
            tooltip: true, key: "componentBarcode", width: 160, align: "center" },
          {
            tooltip: true, key: "operatorName", width: 160, align: "center" },
          { key: "action", width: 150, align: "center", slot: "action" },
        ],
      };
    },
    mounted() {
    },
    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "componentBindings", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = filter;
      },
      addEditHandle(row) {
        this.editData = row || {};
        this.editVisible = true;
      },
      submitHandle(form) {
        if (form.pkId) {
          // 编辑
          this.$http.put("basic", "componentBindings", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("编辑成功");
            }
          });
        } else {
          // 新增
          this.$http.post("basic", "componentBindings", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("新增成功");
            }
          });
        }
      },
    },
  };
</script>